import React from "react";
import "../../css/sharedStyles.css";
import "./videosPageContainer.css";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import VideoDetailOverlay from "../videoDetailOverlay/videoDetailOverlay.js";
import ReactPlayer from 'react-player'
import LoaderAnimation from "../loaderAnimation/loaderAnimation.js"

var VideosPageContainer = class VideosPageContainer extends React.Component{
    constructor(props) {
        super(props);
        
    }  



    componentDidMount () {
        window.scrollTo(0, 0);
      }

    triggerVideoPopup(videoID){
        this.props.changeVideoPopupVisibility(true);
        this.props.changeSelectedVideo(videoID);  
    }
  

    render() {
        const routeBase = localStorage.getItem("routeBase"); 
        //if youre on this page, then "this.props.characterInfo.character" already exists. no need to check for it
        if(this.props.videoInfo.videosReadyToShow === true){
            return (
                <div style={{'position':'relative'}}>
                <VideoDetailOverlay 
                    videoInfo = {this.props.videoInfo}
                    changeVideoPopupVisibility = {this.props.changeVideoPopupVisibility}
                    changeSelectedVideo = {this.props.changeSelectedVideo}
                />
               <div> {this.props.videoInfo.videoPopupVisible}</div>
                    <div className = "videosPageTitle">Videos Containing: <span className="">{this.props.characterInfo.character}</span></div>
                    <div className = "videosPageContainer">
                        {
                            this.props.videoInfo.videosArray.map(function(item,index){
                                var videoID = this.props.videoInfo.videosArray[index][0];
                                return <Link to={routeBase + "/videosPage"} key={index}>
                                    {/* link to THIS same page so the redux values update in this component */}
                                    <div className="videoWrapper"
                                        onClick = {()=>{this.triggerVideoPopup(videoID)}}
                                    >
                                        <div className="imageHolder">
                                            <img src={this.props.videoInfo.videosArray[index][3]} />
                                        </div>
                                        <div className="title">{this.props.videoInfo.videosArray[index][1]}</div>
                                    </div>                       
                                </Link>
                            },this)
                        }
                    </div>
                </div>
            );
        }//end if()
        else{
            return(
                <LoaderAnimation text = "Loading Video Database" />
            )
        }
    }//end render()
  }//end class()

  export default VideosPageContainer;


// WEBPACK FOOTER //
// ./src/components/videosPage/videosPageContainer.js